import { useEffect, useState } from "react";
import api from "@/lib/api";
import { GlassCard, PageLoader } from "@/components/shared";
import { Bell, AlertTriangle, Info, XCircle, Check } from "lucide-react";

const sevIcon = { warning: AlertTriangle, critical: XCircle, info: Info };
const sevColor = { warning: "text-amber-400", critical: "text-rose-400", info: "text-cyan-400" };

export default function Alerts() {
  const [alerts, setAlerts] = useState(null);
  const load = () => api.get("/alerts").then((r) => setAlerts(r.data));
  useEffect(() => { load(); }, []);
  if (!alerts) return <PageLoader />;

  const markRead = async (id) => { await api.post(`/alerts/${id}/read`); load(); };

  return (
    <div>
      <div className="mb-6 flex items-center gap-2"><Bell className="h-5 w-5 text-cyan-400" /><h1 className="font-display text-2xl font-bold text-slate-50">Alerts</h1></div>
      {alerts.length === 0 ? (
        <GlassCard className="p-8 text-center text-slate-400">No alerts. Everything looks healthy.</GlassCard>
      ) : (
        <div className="space-y-3">
          {alerts.map((a) => {
            const Icon = sevIcon[a.severity] || Info;
            return (
              <GlassCard key={a.id} className={`flex items-start gap-3 p-4 ${a.read ? "opacity-60" : ""}`} data-testid={`alert-${a.id}`}>
                <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${sevColor[a.severity]}`} />
                <div className="flex-1">
                  <div className="flex items-center gap-2"><span className="text-sm font-semibold text-slate-100">{a.category}</span><span className="text-xs text-slate-500">{new Date(a.created_at).toLocaleString()}</span></div>
                  <p className="mt-0.5 text-sm text-slate-400">{a.message}</p>
                </div>
                {!a.read && <button onClick={() => markRead(a.id)} data-testid={`alert-read-${a.id}`} className="inline-flex items-center gap-1 rounded-md border border-slate-700 px-2 py-1 text-xs text-slate-400 hover:text-emerald-300"><Check className="h-3 w-3" /> Mark read</button>}
              </GlassCard>
            );
          })}
        </div>
      )}
    </div>
  );
}
